<template>
  <div>
    <h1 class="mt-10 text-xl font-semibold text-gray-900">Variants</h1>
    <Table class="mt-10" :columns="columns" :data="variants" :is-accessible="true" @view="showVariantInformations">
      <template #title="{ row }">
        <div class="flex items-center">
          <div class="h-10 w-10 shrink-0">
            <img class="h-10 w-10 rounded-full" :src="row.imageUrl" alt="" />
          </div>
          <div class="ml-4">
            <div class="font-medium text-gray-900">
              <p>{{ row.title }}</p>
              <FieldSpan
                class="ml-3 mt-1"
                :style-to-add="getApprovalStatusFieldDisplayStyle(row.approvalStatus)"
                :value="row.approvalStatus"
              />
              <FieldSpan
                class="ml-3 mt-1"
                :style-to-add="getContractStatusFieldDisplayStyle(row.contractStatus)"
                :value="row.contractStatus"
              />
              <FieldSpan
                class="ml-3 mt-1"
                :style-to-add="getEnabledFieldDisplayStyle(row.enabled)"
                :value="row.enabled ? 'Oui' : 'Non'"
              />
            </div>
            <div class="text-gray-500">{{ row.vendor }}</div>
          </div>
        </div>
      </template>

      <template #price="{ row }">
        <p class="text-gray-900">{{ formatPrice(row.price) }}</p>
      </template>
    </Table>
    <Modal :open="variantToShow != null" @close="variantToShow = null">
      <VariantContractList :variant="variantToShow" />
    </Modal>
  </div>
</template>

<script>
import { Modal, Table, FieldSpan, formatPrice } from "@estaly/ui";
import VariantContractList from "@/views/products/details/variant/details/contracts/VariantContractList.vue";

export default {
  components: {
    Table,
    VariantContractList,
    Modal,
    FieldSpan,
  },
  data: () => {
    return {
      variantToShow: null,
    };
  },
  computed: {
    columns() {
      return [
        { label: "Titre", field: "title", slot: "title" },
        { label: "Catégorie", field: "category" },
        { label: "Prix", field: "price", slot: "price" },
        { label: "Source", field: "source" },
        { label: "Reference Id", field: "referenceId" },
      ];
    },
  },
  methods: {
    formatPrice,
    showVariantInformations(variant) {
      this.variantToShow = variant;
    },
    getContractStatusFieldDisplayStyle(status) {
      let result;
      switch (status) {
        case "pending":
          result = "bg-yellow-100 text-yellow-800";
          break;
        case "matched":
          result = "bg-green-100 text-green-800";
          break;
        case "non_warrantable":
          result = "bg-red-100 text-red-800";
          break;
        default:
          result = "bg-blue-100 text-blue-800";
      }
      return result;
    },

    getApprovalStatusFieldDisplayStyle(status) {
      let result;
      switch (status) {
        case "to_be_approved":
          result = "bg-yellow-100 text-yellow-800";
          break;
        case "approved":
          result = "bg-green-100 text-green-800";
          break;
        case "refused":
          result = "bg-red-100 text-red-800";
          break;
        default:
          result = "bg-blue-100 text-blue-800";
      }
      return result;
    },
    getEnabledFieldDisplayStyle(isEnabled) {
      return isEnabled ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    },
  },
  props: ["variants", "productId"],
};
</script>
